class Q extends Object {
  constructor() {
    super();

    this.queue = [];
  }

  /**
   * 添加数据至队列
   * @param {Object|Array} obj 数据对象，如果类型是数组，则认为需要添加多个数据对象
   */
  add(obj) {
    if (Object.prototype.toString.call(obj) === '[object Array]') {
      this.queue = this.queue.concat(obj);
    } else {
      this.queue.push(obj);
    }
  }

  get() {
    return this.queue.slice(0);
  }

  clean() {
    this.queue = [];
  }
}

export default Q;
